import ImpactCalculatorForm from 'src/javascripts/components/forms/ImpactCalculatorForm';

export default class AccountsImpactCalculatorsNew {

  constructor() {}

  render() {

    ImpactCalculatorForm();

  }

}